import { render } from "./MRP_Manufacturer_Dialog.vue?vue&type=template&id=afdf1942&scoped=true"
import script from "./MRP_Manufacturer_Dialog.vue?vue&type=script&lang=js"
export * from "./MRP_Manufacturer_Dialog.vue?vue&type=script&lang=js"

import "./MRP_Manufacturer_Dialog.vue?vue&type=style&index=0&id=afdf1942&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdf1942"]])

export default __exports__